import {Outlet} from 'react-router-dom'
import './PageLayout.scss'

const PageLayout = () => {
    return (
        <div className='whole-container'>
            <Outlet />
        </div>
    )
}

export default PageLayout;